export default __webpack_public_path__ + "static/media/cancel.f8458a52.svg";